export const handleDramaturgyTypeByFormat = (format) => {
  const dramaturgyLong = ["Novela", "Supersérie", "Vertical", "Globo Romance"];
  const dramaturgyShort = [
    "Curta",
    "Documentário",
    "Especial",
    "Filme/Telefilme",
    "Minissérie",
    "Podcast",
    "Quadro",
    "Série",
    "Filme",
    "Websérie",
  ];
  if (dramaturgyLong.includes(format)) return "Dramaturgia Longa";
  if (dramaturgyShort.includes(format)) return "Dramaturgia Curta";
};
